"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M19 14a5 5 0 0 0-3.59 1.53l-5.49-2.75A4.91 4.91 0 0 0 10 12a4.91 4.91 0 0 0-.08-.78l5.49-2.75A5 5 0 1 0 14 5a4.91 4.91 0 0 0 .08.78L8.59 8.53a5 5 0 1 0 0 6.94l5.49 2.75A4.91 4.91 0 0 0 14 19a5 5 0 1 0 5-5Z"
}), 'Share');

exports.default = _default;